import { useState } from "react";
import { Layout, Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authAdminSlice";
import logo from "../../assets/JomUntu Logo.png";

const { Header } = Layout;

export const AppHeader = () => {
  const { token, isAdmin, isRestaurant } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: "Home", id: "home" },
    { name: "About", id: "about" },
    { name: "Contact", id: "contact" },
  ];

  const handleLogout = () => {
    dispatch(logout());
  };

  const handlePanel = () => {
    if (isAdmin) {
      navigate("/admin-panel/add-new-food");
    } else if (isRestaurant) {
      navigate("/restaurant-panel/restaurant-profile");
    }
  };

  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setOpen(false); // Close drawer on mobile
    }
  };

  return (
    <Header className="bg-transparent px-4 z-50 w-full pt">
      <div className="flex flex-col justify-between items-center h-full border-b-2 border-opacity-30 border-white pb-2 mx-4 md:mx-24">
        {/* Desktop */}
        <div className="hidden md:flex w-full justify-between items-center">
          <div className="flex gap-8">
            {menuItems.map((item) => (
              <div
                key={item.id}
                className="text-white font-clash px-4 py-2 transition-colors cursor-pointer"
                onClick={() => handleScroll(item.id)}
              >
                {item.name}
              </div>
            ))}
          </div>

          <div className="flex gap-4">
            {!token ? (
              <>
                <Button className="bg-transparent text-white border-white border font-clash rounded-full px-6 py-2 cursor-pointer">
                  <Link to={"/register"}>Sign Up</Link>
                </Button>
                <Button className="bg-white text-black font-clash rounded-full px-6 py-2 cursor-pointer">
                  <Link to={"/login"}>Login</Link>
                </Button>
              </>
            ) : (
              <>
                {(isAdmin || isRestaurant) && (
                  <Button
                    className="bg-transparent text-white border-white border font-clash rounded-full px-6 py-2 cursor-pointer"
                    onClick={handlePanel}
                  >
                    Dashboard
                  </Button>
                )}
                <Button
                  className="bg-transparent text-white border-white border font-clash rounded-full px-6 py-2 cursor-pointer"
                  onClick={handleLogout}
                >
                  Log Out
                </Button>
              </>
            )}
          </div>
        </div>

        {/* Mobile */}
        <div className="md:hidden flex justify-between items-center w-full pt-4">
          <a href="#" onClick={() => window.location.reload()}>
            <img src={logo} alt="Logo" className="h-10" />
          </a>

          <Button
            type="text"
            className="text-white cursor-pointer"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
          />
        </div>

        <Drawer
          title="Menu"
          placement="right"
          onClose={() => setOpen(false)}
          open={open}
          className="font-clash"
        >
          <div className="flex flex-col gap-4">
            {menuItems.map((item) => (
              <Button
                key={item.id}
                type="text"
                block
                className="cursor-pointer"
                onClick={() => handleScroll(item.id)}
              >
                {item.name}
              </Button>
            ))}

            <div className="mt-8 flex flex-col gap-4 bg-transparent">
              {!token ? (
                <>
                  <Button
                    block
                    className="bg-white text-black rounded-full cursor-pointer"
                  >
                    <Link to={"/register"}>Sign Up</Link>
                  </Button>
                  <Button
                    block
                    className="bg-white text-black rounded-full cursor-pointer"
                    onClick={() => setOpen(false)}
                  >
                    <Link to={"/login"}>Login</Link>
                  </Button>
                </>
              ) : (
                <>
                  {(isAdmin || isRestaurant) && (
                    <Button
                      block
                      className="bg-white text-black rounded-full cursor-pointer"
                      onClick={() => {
                        handlePanel();
                        setOpen(false);
                      }}
                    >
                      Dashboard
                    </Button>
                  )}
                  <Button
                    block
                    className="bg-white text-black rounded-full cursor-pointer"
                    onClick={() => {
                      handleLogout();
                      setOpen(false);
                    }}
                  >
                    Log Out
                  </Button>
                </>
              )}
            </div>
          </div>
        </Drawer>
      </div>
    </Header>
  );
};
